/* WTP Mobile Sticky Add to Cart — self-contained, safe across Craft theme updates.
   Does not reimplement add-to-cart logic: it mirrors the real product-form
   button/price and forwards clicks to the real button, so the theme's own
   AJAX cart, cart drawer, error handling, and analytics run unmodified. */
(function () {
  function init() {
    var bar = document.getElementById('wtp-msatc');
    if (!bar) return;

    var mainProductInfo = document.querySelector('product-info[id^="MainProduct-"]');
    if (!mainProductInfo) return;

    var sectionId = mainProductInfo.getAttribute('data-section');
    var mainSubmitBtn = mainProductInfo.querySelector('.product-form__submit');
    if (!mainSubmitBtn) return;

    var priceEl = sectionId ? document.getElementById('price-' + sectionId) : null;
    var barPriceEl = document.getElementById('wtp-msatc-price');
    var barButton = document.getElementById('wtp-msatc-button');
    var barButtonText = document.getElementById('wtp-msatc-button-text');

    var scrolledPastButton = false;
    var overlayOpen = false;
    var hideTimer = null;

    function updateVisibility() {
      var shouldShow = scrolledPastButton && !overlayOpen;
      window.clearTimeout(hideTimer);

      if (shouldShow) {
        bar.hidden = false;
        requestAnimationFrame(function () {
          bar.classList.add('wtp-msatc--visible');
        });
      } else {
        bar.classList.remove('wtp-msatc--visible');
        hideTimer = window.setTimeout(function () {
          bar.hidden = true;
        }, 260);
      }
    }

    function syncButtonState() {
      var isDisabled = mainSubmitBtn.disabled || mainSubmitBtn.getAttribute('aria-disabled') === 'true';
      var isLoading = mainSubmitBtn.classList.contains('loading');

      barButton.toggleAttribute('disabled', !!isDisabled);
      barButton.classList.toggle('wtp-msatc__button--loading', !!isLoading);

      var realLabel = mainSubmitBtn.querySelector('span');
      if (realLabel && barButtonText) {
        var text = realLabel.textContent.trim();
        if (text) barButtonText.textContent = text;
      }
    }

    function syncPrice() {
      if (priceEl && barPriceEl) {
        barPriceEl.innerHTML = priceEl.innerHTML;
      }
    }

    // Initial state
    syncButtonState();
    syncPrice();

    // Keep the sticky bar's price and button state mirrored to the real ones,
    // so variant changes, sold-out states, and add-to-cart loading all sync
    // automatically without duplicating that logic here.
    var buttonObserver = new MutationObserver(syncButtonState);
    buttonObserver.observe(mainSubmitBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      childList: true,
      subtree: true,
    });

    if (priceEl) {
      var priceObserver = new MutationObserver(syncPrice);
      priceObserver.observe(priceEl, { childList: true, subtree: true });
    }

    // Show the bar only once the real Add to Cart button has scrolled
    // off the top of the screen; hide it again if the customer scrolls back up.
    if ('IntersectionObserver' in window) {
      var intersectionObserver = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          scrolledPastButton = entry.boundingClientRect.bottom < 0;
          updateVisibility();
        },
        { threshold: 0 }
      );
      intersectionObserver.observe(mainSubmitBtn);
    }

    // Hide while the cart drawer (or any overlay that locks body scroll) is open
    var bodyObserver = new MutationObserver(function () {
      overlayOpen = document.body.classList.contains('overflow-hidden');
      updateVisibility();
    });
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    // Forward clicks to the real Add to Cart button so all existing
    // add-to-cart behavior (AJAX, cart drawer, errors, analytics) runs untouched
    barButton.addEventListener('click', function () {
      if (barButton.hasAttribute('disabled')) return;
      mainSubmitBtn.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();